export const generateDynamicLink = async (cod) => {
    const bodyToken = {
        "dynamicLinkInfo": {
            "domainUriPrefix": "https://murilocim.page.link",
            "link": `https://www.murilo.cim.br/ImovelSelecionado.aspx?cod=${cod}`,
            "androidInfo": {
                "androidPackageName": "br.cim.murilo"
            },
            "iosInfo": {
                "iosBundleId": "br.cim.murilo"
            }
        }
    };

    return fetch('https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=AIzaSyCBE3D-2INak80-UlF-uI9tXhGjDfr7y1o', {
        method: "post",
        body: JSON.stringify(bodyToken)
    })
}